import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-authenticator',
  templateUrl: './authenticator.component.html',
  styleUrls: ['./authenticator.component.css']
})
export class AuthenticatorComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute){ }

  ngOnInit(): void {

    this.getToken();
  }

  getToken(){

    this.activatedRoute.queryParams.subscribe({
      next: params => {
        this.router.navigate([''], {queryParams: {token: params["token"], usuaDsRe: params["usuaDsRe"]}});
      }
    });
  }


}
